/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { OrganizationApiConfiguration as __Configuration } from '../organization-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ModelQueryResultAppVersionInfo } from '../models/model-query-result-app-version-info';
@Injectable({
  providedIn: 'root',
})
class AppUpdatesService extends __BaseService {
  static readonly UploadFilePath = '/api/organization/app/updates';
  static readonly DownloadFilePath = '/updates/download/{appId}-{platform}.{extension}';
  static readonly GetPath = '/api/organization/app/updates/check';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  UploadFileResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/organization/app/updates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }  UploadFile(): __Observable<null> {
    return this.UploadFileResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `AppUpdatesService.DownloadFileParams` containing the following parameters:
   *
   * - `platform`:
   *
   * - `extension`:
   *
   * - `appId`:
   */
  DownloadFileResponse(params: AppUpdatesService.DownloadFileParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/updates/download/${params.appId}-${params.platform}.${params.extension}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `AppUpdatesService.DownloadFileParams` containing the following parameters:
   *
   * - `platform`:
   *
   * - `extension`:
   *
   * - `appId`:
   */
  DownloadFile(params: AppUpdatesService.DownloadFileParams): __Observable<null> {
    return this.DownloadFileResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `AppUpdatesService.GetParams` containing the following parameters:
   *
   * - `platform`:
   *
   * - `appId`:
   *
   * @return Success
   */
  GetResponse(params: AppUpdatesService.GetParams): __Observable<__StrictHttpResponse<ModelQueryResultAppVersionInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.platform != null) __params = __params.set('platform', params.platform.toString());
    if (params.appId != null) __params = __params.set('appId', params.appId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/app/updates/check`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ModelQueryResultAppVersionInfo>;
      })
    );
  }
  /**
   * @param params The `AppUpdatesService.GetParams` containing the following parameters:
   *
   * - `platform`:
   *
   * - `appId`:
   *
   * @return Success
   */
  Get(params: AppUpdatesService.GetParams): __Observable<ModelQueryResultAppVersionInfo> {
    return this.GetResponse(params).pipe(
      __map(_r => _r.body as ModelQueryResultAppVersionInfo)
    );
  }
}

module AppUpdatesService {

  /**
   * Parameters for DownloadFile
   */
  export interface DownloadFileParams {
    platform: string;
    extension: string;
    appId: string;
  }

  /**
   * Parameters for Get
   */
  export interface GetParams {
    platform?: string;
    appId?: string;
  }
}

export { AppUpdatesService }
